export default [
    {
        path: '/warehouse-group/list',
        name: 'warehouse_group_list',
        component: () => import('@src/warehouse-group/warehouse-group-list'),
        meta: {
            title: 'Lagergruppen',
            role: 'ROLE_SHOW_WAREHOUSE_GROUP',
        },
    },
    {
        path: '/warehouse-group/detail/:id',
        name: 'warehouse_group_detail',
        component: () => import('@src/warehouse-group/warehouse-group-detail'),
        meta: {
            title: 'Lagergruppe bearbeiten',
            role: 'ROLE_EDIT_WAREHOUSE_GROUP',
        },
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
    },
];
